import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  logoUrl: string;
  title: string;
}

interface StyledLogoProps {
  src: string;
  alt: string;
}

const HeaderContainer = styled.div`
  background: linear-gradient(to bottom, #AFCF88, #8BA96E);
  color: white;
  padding: 20px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
`;

const Logo = styled.img<StyledLogoProps>`
  height: 50px;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 16px;
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 14px;
`;

const LogoutButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const Header: React.FC<HeaderProps> = ({ logoUrl, title }) => {
  const { user, logout, isLoading } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <HeaderContainer>
      <LeftSection>
        <Logo src={logoUrl} alt="Logo" />
        <span>{title}</span>
      </LeftSection>
      <RightSection>
        {user && (
          <UserInfo>
            <div>Welcome, {user.fullName}</div>
            <div>{user.email}</div>
          </UserInfo>
        )}
        <LogoutButton onClick={handleLogout} disabled={isLoading}>
          {isLoading ? 'Logging out...' : 'Logout'}
        </LogoutButton>
      </RightSection>
    </HeaderContainer>
  );
};

export default Header; 